import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Spinner, Text } from 'telia-front-react';
import GuideStore, { Programme } from '../../stores/GuideStore';
import ChannelProgramme from './ChannelProgramme';

export interface ChannelGuideProps {
  channelId: string;
  descriptionMaxLength?: number;
  guideStore?: GuideStore;
}

@observer
class ChannelGuide extends React.Component<ChannelGuideProps> {
  @observable accessor status: string;

  constructor(props: ChannelGuideProps, context: any) {
    super(props, context);

    this.status = props.guideStore.getStatus(props.channelId);
  }

  public async componentDidMount() {
    const { guideStore, channelId } = this.props;
    await guideStore.fetchGuideByChannelId(channelId);
    this.status = guideStore.getStatus(channelId);
  }

  private renderProgrammes() {
    const { guideStore, channelId, descriptionMaxLength } = this.props;
    const programmes = guideStore.getProgrammes(channelId);
    const shouldShowLine = (index: number) => index !== programmes.length - 1;
    const isFirst = (index: number) => index === 0;
    return programmes.map((programme: Programme, index: number) => (
      <ChannelProgramme key={index} programme={programme} line={shouldShowLine(index)} first={isFirst(index)} descriptionMaxLength={descriptionMaxLength} />
    ));
  }

  public render() {
    return this.status === 'FETCHED' ? <Text>{this.renderProgrammes()}</Text> : <Spinner />;
  }
}

export default inject('guideStore')(ChannelGuide);
